import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import store from "@/store";
import router from "@/router";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import { fufillmentDetailModel } from "@/models/fulfillment/fulfillment-detail";
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api";

export default function useFulfillmentImportDetail() {
  const STATUS_SUCCESS = 0;
  const STATUS_ERROR = 1;

  const {
    fetchTableFulfillmentImportTrackingNoDetail,
  } = fufillmentDetailModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSelectFilter,
  } = useFilterHeaderTable();

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal();

  const importRef = ref();

  const loading = reactive({
    tableData: false,
  });

  const formStatus = reactive({
    validFrom: null,
    validThrough: null,
    status: null,
  });

  const statusOption = ref([
    { label: "Success", value: STATUS_SUCCESS },
    { label: "Error", value: STATUS_ERROR },
  ]);

  const fields = [
    { key: "seq", label: "No." },
    { key: "ffm_ref", label: "FFM_Ref" },
    { key: "trackingno", label: "TrackingNo" },
    { key: "status", label: "Status" },
    { key: "status_desc", label: "Status Description" },
  ];

  const importTable = reactive({
    payload: [],
  });

  const resolveImportStatusLabel = (status) => {
    switch (status) {
      case STATUS_SUCCESS:
        return "Success";
      case STATUS_ERROR:
        return "Error";
      default:
        return "None";
    }
  };

  const resolveImportStatusClass = (status) => {
    switch (status) {
      case STATUS_SUCCESS:
        return "success";
      case STATUS_ERROR:
        return "error";
      default:
        return "None";
    }
  };

  const fetchImportList = () => {
    loading.tableData = true;
    fetchTableFulfillmentImportTrackingNoDetail.payload.ImportId =
      router.currentRoute.params.ref;
    fetchTableFulfillmentImportTrackingNoDetail.payload.Page =
      pagination.currentPage;
    fetchTableFulfillmentImportTrackingNoDetail.payload.Limit =
      pagination.perPage;
    fetchTableFulfillmentImportTrackingNoDetail.payload.Filters = filters;
    fetchTableFulfillmentImportTrackingNoDetail.payload.Ordering =
      ordering.value;
    store
      .dispatch("api/apiRequest", fetchTableFulfillmentImportTrackingNoDetail)
      .then((response) => {
        importTable.payload = response.data.resp.datalist;
        pagination.rows = response.data.resp.datalist.length;
        pagination.totalRows = response.data.resp.filteredrecord;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchImportList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchImportList();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    fetchImportList();
  });

  const onUploadCoverImage = (image) => {
    form.image_1.file = image.file;
    form.image_1.url = image.url;
  };

  return {
    importRef,
    formStatus,
    fields,
    loading,
    importTable,
    statusOption,
    resolveImportStatusLabel,
    resolveImportStatusClass,
    pagination,
    onPageChange,
    onFilterEntity,
    onSelectFilter,
    onUploadCoverImage,
  };
}
